export default {
    login() {
        var url = "content/login/cek";
        return url;
    },
    
    loginSubmit() {
        var url = "content/login/submit";
        return url;
    },
    
    historyAbsen() {
        var url = "content/karyawan/history";
        return url;
    },
    
    karyawanList() {
        var url = "content/karyawan/list";
        return url;
    },
    
    historyGajian() {
        var url = "content/karyawan/history-gajian";
        return url;
    },

    rangkumanDetail() {
        var url = "content/rangkuman/detail";
        return url;
    },

    keuangan() {
        var url = "content/keuangan/list";
        return url;
    },

    SimpanKeuangan() {
        var url = "content/keuangan/simpan";
        return url;
    },

    getKangTagih() {
        var url = "content/beatcom/kangtagih";
        return url;
    },

    simpanGaji() {
        var url = "content/karyawan/gajian";
        return url;
    },

    AbsenNow() {
        var url = "content/beranda/absen-today";
        return url;
    },
}


// WEBPACK FOOTER //
// ./src/globalFunc/InterfaceAbsensi.js